import styled from 'styled-components';
import CrossIcon from '@bufferapp/ui/Icon/Icons/Cross';
import PencilIcon from '@bufferapp/ui/Icon/Icons/Pencil';
import { grayDarker } from '@bufferapp/ui/style/colors';
import { Button } from '@bufferapp/ui';

export const StyledCrossIcon = styled(CrossIcon)`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const StyledPencilIcon = styled(PencilIcon)`
  color: white;
  padding: 7px;
  cursor: pointer;
`;

export const PencilIconWrapper = styled.div`
  display: flex;
  margin-left: auto;
`;

export const TextWrapper = styled.div`
  color: white;
  margin: auto;
  font-size: 14px;
  margin-left: 10px;
`;

export const CrossIconWrapper = styled.div`
  position: absolute;
  top: 8px;
  right: 8px;
  color: white;
  display: flex;
  padding: 4px;
  background: ${grayDarker};
  border-radius: 50%;
  cursor: pointer;
`;

export const EditNoteWrapper = styled.div`
  background: linear-gradient(
    180deg,
    rgba(61, 61, 61, 0) 1.56%,
    #3d3d3d 73.96%
  );
  width: 100%;
  display: flex;
`;

export const ButtonWrapper = styled.div`
  margin: auto;
  margin-bottom: 5px;
  color: white;
  background: ${grayDarker};
`;

export const DragDropWrapper = styled.div`
  flex-grow: 1;
  cursor: pointer;
  :hover {
    cursor: move;
  }
`;

export const HoverWrapper = styled.div`
  position: absolute;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const EditButtonsWrapper = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  padding: 8px;
  justify-content: space-between;
`;

export const StyledButton = styled(Button)`
  color: white;
  background: ${grayDarker};
  margin-right: 4px;
  &:hover {
    color: white;
  }
  &:last-child{
    margin-right: 0;
  }
  button{
    justify-content: center;
  }
`;

export const NoteButton = styled(StyledButton)`
  flex-grow: 4;
`;
